import {defineAsyncComponent} from 'vue';
import popupUtil from '@/commons/popupUtil.js';

const saVoucherList = defineAsyncComponent(() => import('@/views/salary/payment/SAVoucherList.vue'));
const saAccountingList = defineAsyncComponent(() => import('@/views/salary/accounting/SAAccountingList.vue'));
const popupSACreateVoucher = defineAsyncComponent(() => import('@/views/salary/payment/SACreateVoucher.vue'));
const popupSASalaryAccountingDetail = defineAsyncComponent(() =>
  import('@/views/salary/accounting/SASalaryAccountingDetail.vue'),
);
const popupSACreateVoucherResult = defineAsyncComponent(() =>
  import('@/views/salary/payment/SACreateVoucherResult.vue'),
);
const popupSAChooseAccountingVoucher = defineAsyncComponent(() =>
  import('@/views/salary/accounting/SAChooseAccountingVoucher.vue'),
);
export function registerSalary(app) {
  
  const registerConfig = {
    SAVoucherList: saVoucherList,
    SAAccountingList: saAccountingList,
    SACreateVoucher: popupSACreateVoucher,
    SASalaryAccountingDetail: popupSASalaryAccountingDetail,
    SACreateVoucherResult: popupSACreateVoucherResult,
    SAChooseAccountingVoucher: popupSAChooseAccountingVoucher
  };
  const keys = Object.keys(registerConfig);

  keys.filter(key => {
    app.component(key, registerConfig[key]);
  });

  popupUtil.registerPopup(keys, 'Salary');
}
